import { useCommentsChannels } from '~publish/components/CommentsSidebar/useCommentsChannels'

import { AllChannelsView } from './AllChannelsView'
import { useMixpanelCommunityRecording } from './hooks/tracking/useMixpanelCommunityRecording'

import type { JSX } from 'react'

export const CommunityPage = (): JSX.Element => {
  const { loading } = useCommentsChannels()

  // Record Mixpanel session when user visits CommunityPage
  useMixpanelCommunityRecording()

  if (loading) {
    return <></>
  }

  return <AllChannelsView />
}
